// extracted by mini-css-extract-plugin
export default {"root":"IconChevronLeft_root__wpYpo"};